/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { createEmptyStateResource, EMPTY_STRING, mapToResource, StateResource } from '@common/tech-shared';
import { UserProfileResource, UserProfileService } from '@alfa-client/user-profile-shared';
import { Component, inject, OnInit } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Component({
  selector: 'alfa-user-profile-search-container',
  templateUrl: './user-profile-search-container.component.html',
  styleUrls: ['./user-profile-search-container.component.scss'],
  standalone: false,
})
export class UserProfileSearchContainerComponent implements OnInit {
  public readonly service = inject(UserProfileService);

  _searchedUserProfiles$: Observable<StateResource<UserProfileResource>[]> = of([]);
  _userProfile$: Observable<StateResource<UserProfileResource>> = of(createEmptyStateResource<UserProfileResource>());

  initials: string = '';

  ngOnInit(): void {
    this._userProfile$ = this.service.getAssignedUserProfileFromVorgang();
    this._searchedUserProfiles$ = this.getSearchUserProfiles();
    this.service.search(EMPTY_STRING);
  }

  getSearchUserProfiles(): Observable<StateResource<UserProfileResource>[]> {
    return this._userProfile$.pipe(
      mapToResource<UserProfileResource>(),
      switchMap((userProfile: UserProfileResource) => this.service.getSearchedUserProfiles(userProfile?.username)),
    );
  }

  public searched(searchBy: string): void {
    this.service.search(searchBy);
  }
}
